module.exports = __webpack_public_path__ + "img/GOFR_RGB_high-res.02d54e3c.png";